import { render } from "./index.vue?vue&type=template&id=2783a6f6"
import script from "./partner?vue&type=script&lang=js&external"
export * from "./partner?vue&type=script&lang=js&external"

import "./partner.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__